import type { CadenceTask } from "../../api/cadence.ts";
import type { Lead } from "../../types.ts";
import { filterCadenceLeads, selectedLeadSummary } from "../CadenceCalendar.helpers.ts";

type LeadPickerProps = {
  leads: Lead[];
  tasks: CadenceTask[];
  query: string;
  selectedLeadIds: string[];
  onQueryChange: (query: string) => void;
  onToggleLead: (leadId: string) => void;
};

export function LeadPicker({
  leads,
  tasks,
  query,
  selectedLeadIds,
  onQueryChange,
  onToggleLead,
}: LeadPickerProps) {
  const visibleLeads = filterCadenceLeads(leads, tasks, query);
  const selected = new Set(selectedLeadIds);

  return (
    <section className="cadence-lead-picker" aria-label="Selecionar leads">
      <div className="cadence-form-row">
        <label htmlFor="cadence-lead-search">Leads</label>
        <span>{selectedLeadSummary(selectedLeadIds.length)}</span>
      </div>
      <input
        id="cadence-lead-search"
        className="cadence-input"
        value={query}
        onChange={(event) => onQueryChange(event.currentTarget.value)}
        placeholder="Buscar por nome, telefone, email ou curso"
      />
      <div className="cadence-lead-list">
        {visibleLeads.map((lead) => {
          const leadId = String(lead.id);
          return (
            <label key={leadId} className={`cadence-lead-option ${selected.has(leadId) ? "is-selected" : ""}`}>
              <input
                type="checkbox"
                checked={selected.has(leadId)}
                onChange={() => onToggleLead(leadId)}
              />
              <span className="cadence-lead-name">{lead.name || lead.phone || "Lead sem nome"}</span>
              <span className="cadence-lead-meta">{lead.phone || lead.email || lead.course || "Sem telefone"}</span>
            </label>
          );
        })}
        {!visibleLeads.length ? <div className="cadence-empty">Nenhum lead encontrado.</div> : null}
      </div>
    </section>
  );
}
